import { isMobile } from '@kizi/comparator-components';
import { useFields } from '@kizi/comparator-core';
import { Div, P } from '@kizi/core-components';
import { IconV2 } from '@kizi/shared-components';
import React from 'react';

const CheckedValue = ({ label, subLabel }) => (
  <Div display="flex" gridGap="8px" alignItems="center">
    <IconV2 name="check" size={32} fill="supplementary.2" />
    <P variant="bodyRegular">{label}</P>
    {isMobile() ? null : (
      <P variant="bodyRegular" color="main.5">
        {subLabel}
      </P>
    )}
  </Div>
);

const UncheckedValue = ({ label }) => (
  <Div display="flex" gridGap="8px" alignItems="center">
    <IconV2 name="cancel" size={18} fill="#A5A7AE" />
    <P variant="bodyRegular" color="#A5A7AE">
      {`Geen ${label}`}
    </P>
  </Div>
);

export const AvailableNetworks = () => {
  const [apiProducts] = useFields(['overview.apiProducts']);

  if (!apiProducts?.value) return null;

  const networks = JSON.parse(apiProducts?.value as string)?.reduce(
    (acc, cur) => {
      if (!acc.includes(cur.network)) {
        acc.push(cur.network);
      }
      return acc;
    },
    [],
  );

  return (
    <Div
      display="flex"
      gridGap={[null, '40px']}
      justifyContent={['space-between', null]}
    >
      {networks.includes('DSL') ? (
        <CheckedValue label={'DSL'} subLabel={'(tot 200 Mbit/s)'} />
      ) : (
        <UncheckedValue label={'DSL'} />
      )}
      {networks.includes('Kabel') ? (
        <CheckedValue label={'Kabel'} subLabel={'(tot 1000 Mbit/s)'} />
      ) : (
        <UncheckedValue label={'Kabel'} />
      )}
      {networks.includes('Glasvezel') ? (
        <CheckedValue label={'Glasvezel'} subLabel={'(tot 8000 Mbit/s)'} />
      ) : (
        <UncheckedValue label={'Glasvezel'} />
      )}
    </Div>
  );
};
